// extracted by mini-css-extract-plugin
export default {"wrapper":"FooterZodiacIconCycle_wrapper__vpzf0","icon":"FooterZodiacIconCycle_icon__jKTko","circle":"FooterZodiacIconCycle_circle__3yf5q"};